import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep';
import ActionLink from './ActionLink';

import Tooltip from './Tooltip';

const DisablerElement = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let tooltip = (isNotEmpty(props, 'children')) ? props.children : "Options not available";
	if(props.text !== undefined) tooltip = props.text;

	const display_inlined = props?.display_inlined ?? false;

	const has_link = (isNotEmpty(props, 'link')) ? props.link : false;

	if(display_inlined) {
		return (
			<div class="gui_disabler is_inlined not_awesome">
				{(tooltip !== false && tooltip != "") && (
					<span class="visible_tooltip">{i18n(tooltip)}</span>
				)}
			</div>
		)
	}

	if(has_link !== false) {
		return (
			<div class="gui_disabler not_awesome">
				<ActionLink
					_href={has_link}
					_class={{other:'is_fullscreen relative_to_container'}}
					tooltip={(tooltip !== false && tooltip != "") ? (
						<Tooltip
							position={props?.tooltip_position ?? 'top'}
							autotranslate={props.tooltip_autostranslate}
							with_icon={false}
						>{tooltip}</Tooltip>
					) : null}
				/>
			</div>
		)
	}

	return (
		<div class="gui_disabler not_awesome">
			{(tooltip !== false && tooltip != "") && (
				<Tooltip
					position={props?.tooltip_position ?? 'top'}
					autotranslate={props.tooltip_autostranslate}
					with_icon={false}
					_class={{ other:'tooltip_disabler' }}
				>{tooltip}</Tooltip>
			)}
		</div>
	);
}

export default injectIntl(DisablerElement);